import {
    AppBar, Divider, Grid, IconButton, Menu, MenuItem, Tab, Tabs,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import React, {
    useEffect, useMemo, useRef, useState,
} from "react";

import { styled } from "@mui/material/styles";
import useStore from "../../store";
import {
    PTMConfirmDialog, PTMDialog, PTMLink, PTMPopover, PTMTooltip,
} from "../../Components";
import PTMIcon from "../../Components/PTMIcon";
import PTMButton from "../../Components/PTMButton";

/* eslint-disable-next-line no-undef */
const onBrowser = _isBrowser;

function SortableItem(props) {
    const {
        tab,
        currentTab,
        setCurrentTab,
        checkTab,
    } = props;

    const [activeClickedTab, setActiveClickedTab] = useState();

    const tabClickHandler = (clickedTab) => {
        if (currentTab === clickedTab.id) {
            setActiveClickedTab(!activeClickedTab ? clickedTab.id : "");
        }
        // console.log(clickedTab);
        setCurrentTab(clickedTab.id);
    };
    const ref = React.useRef();
    React.useEffect(() => {
        if (currentTab === tab.id && ref.current) {
            ref.current.scrollIntoView({
                behaviour: "smooth",
                inline: "center",
            });
        }
    }, [currentTab, tab]);
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    return (
        <Tab
            className={
                currentTab === tab.id ? activeClickedTab === tab.id ? " TabBarSelected TabBarExt" : "TabBarSelected" : ""
            }
            {...a11yProps(tab.id)}
            label={(
                <>
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <span
                        ref={ref}
                        // onClick={() => setCurrentTab(tab.id)}
                        onClick={() => tabClickHandler(tab)}
                    >

                        <FontAwesomeIcon icon={tab.icon} />
                        {tab.isDirty ? "* " : null}
                        {tab.title && (tab.title)}
                        {tab.titleDisplayed}
                    </span>

                    <IconButton
                        className="tabRemoveButton"
                        onClick={() => checkTab(tab.id)}
                    >
                        <FontAwesomeIcon icon="times" />
                    </IconButton>
                    <Divider
                        orientation="vertical"
                        sx={{
                            display: "inline-block",
                            height: 30,
                            borderColor: "rgba(255, 255, 255, 0.5) !important",
                        }}
                    />
                </>
            )}
        />
    );
}

const StyledTabs = styled(Tabs, {
    shouldForwardProp: (prop) => !["tabs"].includes(prop),
})(({ tabs }) => ({
    "& .MuiTabs-scrollButtons": {
        display: tabs.length ? "inline-flex" : "none",
    },
}));

export default function TabBar() {
    // const {
    //     sidebars: { right: { enabled }, setEnabled }, tabs, currentTab, setCurrentTab, closeTab,
    // } = useStore((store) => store.dashboard);
    const enabled = useStore((store) => store.dashboard.sidebars.right.enabled);
    const setEnabled = useStore((store) => store.dashboard.sidebars.setEnabled);
    const tabs = useStore((store) => store.dashboard.tabs);
    const sender = useStore((store) => store.dashboard.sender);
    const setSender = useStore((store) => store.dashboard.setSender);
    const confirmDiscardAll = useStore((store) => store.dashboard.confirmDiscardAll);
    const setConfirmDiscardAll = useStore((store) => store.dashboard.setConfirmDiscardAll);
    const closeAll = useStore((store) => store.dashboard.closeAll);
    const handleCloseAll = useStore((store) => store.dashboard.handleCloseAll);
    const isHelpDesk = useStore((store) => store.app.appInfo.is_helpdesk);
    const currentTab = useStore((store) => store.dashboard.currentTab);
    const setCurrentTab = useStore((store) => store.dashboard.setCurrentTab);
    const closeTab = useStore((store) => store.dashboard.closeTab);
    const currentRoute = useStore((store) => store.app.currentRoute);

    const ref = useRef();

    const [orderedTabs, setOrderedTabs] = useState([]);
    const [confirmDiscard, setConfirmDiscard] = useState(false);
    const [discardTab, setDiscardTab] = useState(false);
    const [contextMenu, setContextMenu] = React.useState(null);
    const [dirtyTabs, setDirtyTabs] = React.useState([]);
    /* eslint-disable-next-line no-unused-vars */
    const [loading, setLoading] = useState(false);

    const toggleSidebar = () => {
        setEnabled("right", !enabled);
        setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
    };
    const checkTab = (id) => {
        const tab = tabs.find((innerTab) => innerTab.id === id);

        if (tab && tab.isDirty) {
            setDiscardTab(id);
            setConfirmDiscard(true);
        } else {
            closeTab(id);
        }
    };

    useEffect(() => {
        setLoading(true);
        return () => {
            setLoading(false);
        };
    }, [currentTab]);

    useEffect(() => {
        const tmpOrderedTabs = orderedTabs.map((item) => ({ ...item, isDirty: false }));

        tabs.forEach((tab) => {
            const tmpOrderedTab = tmpOrderedTabs.find((item) => item.id === tab.id);
            if (!tmpOrderedTab) {
                tmpOrderedTabs.push(tab);
            } else {
                tmpOrderedTab.title = tab.title;
                tmpOrderedTab.isDirty = tab.isDirty || false;
                tmpOrderedTab.popover = tab.popover || null;
            }
        });

        tmpOrderedTabs.forEach((orderedTab) => {
            if (!tabs.find((tab) => tab.id === orderedTab.id)) {
                const tmpIndex = tmpOrderedTabs.findIndex((item) => item.id === orderedTab.id);
                tmpOrderedTabs.splice(tmpIndex, 1);
            }
        });
        setDirtyTabs(tabs.filter((tab) => tab.isDirty));
        if (tabs.length === 0 && confirmDiscardAll) {
            setConfirmDiscardAll(false);
            if (sender) {
                sender.sender.send("close", sender.arg);
                setSender(null);
            }
        }
        setOrderedTabs((tabs.length === 0 && []) || (confirmDiscardAll && tabs.filter((tab) => tab.isDirty)) || (tmpOrderedTabs));
    }, [tabs]);
    useEffect(() => {
        if (currentTab === -1) {
            document.querySelectorAll(".menu-modal").forEach((cls) => {
                cls.style.display = "block";
            });
            document.querySelectorAll(".menu-modal-backdrop").forEach((cls) => {
                cls.style.display = "block";
            });
        } else {
            document.querySelectorAll(".menu-modal").forEach((cls) => {
                cls.style.display = "none";
            });
            document.querySelectorAll(".menu-modal-backdrop").forEach((cls) => {
                cls.style.display = "none";
            });
        }
    }, [currentTab]);
    const closeModal = () => {
        window.dispatchEvent(new CustomEvent("reactToAngular", {
            detail: {
                action: "openRoute",
                value: {
                    route: "/",
                },
            },
        }));
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    const handleContextMenu = (event) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX - 10,
                    mouseY: event.clientY - 10,
                }
                : null,
        );
    };

    const closeContextMenu = () => {
        setContextMenu(null);
    };
    return (useMemo(() => (
        <>
            <PTMConfirmDialog
                title="Änderungen ermittelt"
                open={confirmDiscard}
                setOpen={setConfirmDiscard}
                onConfirm={() => closeTab(discardTab)}
            >
                Dieser Tab enthält Änderungen, möchten Sie diesen wirklich schließen?
            </PTMConfirmDialog>
            {confirmDiscardAll && currentTab === 0 && (
                <PTMDialog
                    customDialogStyle={{ "& .MuiPaper-root.MuiDialog-paper": { width: "50%" } }}
                    title="Änderungen ermittelt - Tabs trotzdem schließen?"
                    open
                    containerId="dashboardDialogContent"
                    onClose={() => setConfirmDiscardAll(false)}
                    footerButtons={[
                        {
                            color: "primary",
                            name: "Alle schließen",
                            icon: "check",
                            click: () => {
                                closeAll();
                                setConfirmDiscardAll(false);
                                setSender(null);
                            },
                        },
                        {
                            color: "error",
                            name: "Abbrechen",
                            icon: "times",
                            click: () => setConfirmDiscardAll(false),
                        },
                    ]}
                >
                    {" "}
                    <Grid container p={2} alignItems="center" sx={{ fontSize: "14px" }}>
                        <Grid item xs={3} sx={{ textAlign: "center", borderBottom: "1px solid" }}>
                            Aktionen
                        </Grid>
                        <Grid item xs={3} sx={{ textAlign: "center", borderBottom: "1px solid" }}>
                            Kategorie
                        </Grid>
                        <Grid item xs sx={{ textAlign: "center", borderBottom: "1px solid" }}>
                            Titel
                        </Grid>
                    </Grid>
                    {dirtyTabs.map((tab) => (
                        <Grid container p={2} alignItems="center" key={tab.id}>
                            <Grid item xs={3} sx={{ textAlign: "center" }}>
                                <PTMButton
                                    popover="Ungespeichert schließen"
                                    variant="contained"
                                    color="error"
                                    onClick={() => closeTab(tab.id)}
                                >
                                    <FontAwesomeIcon icon="times" />
                                    {"\u00A0"}
                                    schließen
                                </PTMButton>
                            </Grid>
                            <Grid item xs={3} sx={{ fontSize: "18px", textAlign: "center" }}>
                                <PTMTooltip title={(tab.component === "Task" && "Aufgaben") || (tab.component === "Contact" && "Kontakte") || (tab.component === "Contract" && "Verträge")}>
                                    <FontAwesomeIcon icon={tab.icon} />
                                </PTMTooltip>
                            </Grid>
                            <Grid item xs sx={{ fontSize: "14px", textAlign: "center" }}>
                                <PTMLink onClick={() => setCurrentTab(tab.id)}>
                                    {tab.title}
                                </PTMLink>
                            </Grid>
                        </Grid>
                    ))}
                </PTMDialog>
            )}
            <AppBar
                // onMouseLeave={closeContextMenu}
                ref={ref}
                position="relative"
                {...(tabs.length > 0 || currentRoute.route !== "/") && { onContextMenu: handleContextMenu }}
                sx={{
                    display: "inline-grid",
                    gridTemplateColumns: "auto auto",
                    justifyContent: "flex-start",
                    alignContent: "center",
                    height: 30,
                    padding: !onBrowser && "20px 0",
                    zIndex: 835,
                }}
            >
                <Tabs
                    id="tab-bar"
                    style={{ paddingRight: 0 }}
                    indicatorColor="secondary"
                    textColor="inherit"
                    // variant="scrollable"
                    // scrollButtons="auto"
                    // aria-label="scrollable auto tabs"
                    value={0}
                    sx={{
                        paddingRight: 30,
                        "& .MuiTabs-indicator": {
                            display: "none",
                        },
                        "& .TabBarSelected": {
                            opacity: 1,
                        },

                        "& .TabBarExt": {
                            maxWidth: "initial !important",
                        },
                        "& .Mui-selected:not(.TabBarSelected)": {
                            opacity: 0.7,
                        },
                        "& button": {
                            paddingRight: "6px",
                            minWidth: 15,
                            maxWidth: 200,
                            flexDirection: "row",
                            lineHeight: 21,
                            "& span:first-child": {
                                display: "block",
                                // lineHeight: 5,
                                textTransform: "none",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                "& svg": {
                                    marginRight: 3,
                                },
                            },
                        },
                    }}
                >
                    <Tab
                        className={currentTab === 0 ? "TabBarSelected" : ""}
                        {...a11yProps(0)}
                        label={(
                            <>
                                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                                <span
                                    onClick={() => setCurrentTab(0)}
                                >
                                    <FontAwesomeIcon icon="tachometer-alt" />
                                    Dashboard
                                </span>
                            </>
                        )}
                    />
                    <Divider
                        orientation="vertical"
                        sx={{
                            display: "inline-block",
                            height: 30,
                            borderColor: "rgba(255, 255, 255, 0.5) !important",
                        }}
                    />
                    {currentRoute.route !== "/" ? (
                        <Tab
                            className={currentTab === -1 ? "TabBarSelected" : ""}
                            {...a11yProps(-1)}
                            label={(
                                <>
                                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                                    <span
                                        onClick={() => setCurrentTab(-1)}
                                    >
                                        <FontAwesomeIcon icon={currentRoute.icon} />
                                        {currentRoute.title}
                                    </span>

                                    <IconButton className="tabRemoveButton" onClick={() => closeModal()}>
                                        <FontAwesomeIcon icon="times" />
                                    </IconButton>
                                    <Divider
                                        orientation="vertical"
                                        sx={{
                                            display: "inline-block",
                                            height: 30,
                                            borderColor: "rgba(255, 255, 255, 0.5) !important",
                                        }}
                                    />
                                </>
                            )}
                        />
                    ) : null}
                </Tabs>
                <StyledTabs
                    id="tab-bar-2"
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs"
                    value={0}
                    tabs={orderedTabs}
                    sx={{
                        paddingRight: 30,
                        "& .MuiTabs-indicator": {
                            display: "none",
                        },
                        "& .TabBarSelected": {
                            opacity: 1,
                        },

                        "& .TabBarExt": {
                            maxWidth: "initial !important",
                        },
                        "& .Mui-selected:not(.TabBarSelected)": {
                            opacity: 0.7,
                        },
                        "& button": {
                            paddingRight: "6px",
                            minWidth: 15,
                            maxWidth: 200,
                            flexDirection: "row",
                            lineHeight: 21,
                            "& span:first-child": {
                                display: "block",
                                // lineHeight: 5,
                                textTransform: "none",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                "& svg": {
                                    marginRight: 3,
                                },
                            },
                        },
                    }}
                >
                    {/* <SortableContext items={orderedTabs} strategy={horizontalListSortingStrategy}> */}
                    {orderedTabs.map((tab) => (
                        // tab.popover ? (
                        <PTMPopover content={tab.popover}>
                            <SortableItem
                                currentTab={currentTab}
                                setCurrentTab={setCurrentTab}
                                checkTab={checkTab}
                                id={tab.id}
                                key={tab.id}
                                index={tab.id}
                                tab={tab}
                            />
                        </PTMPopover>
                        // ) : (
                        //     <SortableItem
                        //         currentTab={currentTab}
                        //         setCurrentTab={setCurrentTab}
                        //         checkTab={checkTab}
                        //         id={tab.id}
                        //         key={tab.id}
                        //         index={tab.id}
                        //         tab={tab}
                        //     />
                        // )
                    ))}
                    {/* </SortableContext> */}
                </StyledTabs>
                <Divider orientation="vertical" />
                {!isHelpDesk && (
                    <IconButton
                        color="inherit"
                        onClick={toggleSidebar}
                        sx={{
                            ...onBrowser ? {
                                width: 20,
                                position: "absolute",
                                right: 10,
                                top: 2,
                                fontSize: 20,
                            } : {
                                width: 20,
                                position: "absolute",
                                right: 10,
                                top: "50%",
                                fontSize: 20,
                                transform: "translateY(-50%)",
                            },
                        }}
                    >
                        <PTMIcon
                            icon="columns"
                            popover="Menü aus-/einklappen"
                            style={{ lineHeight: 0 }}
                        />
                        {/* <FontAwesomeIcon icon={enabled ? "chevron-right" : "columns"} /> */}
                    </IconButton>
                )}
            </AppBar>
            <Menu
                onBackdropClick={closeContextMenu}
                onMouseLeave={closeContextMenu}
                open={contextMenu !== null}
                anchorReference="anchorPosition"
                sx={{
                    visibility: "hidden",
                    "& .MuiPaper-root": {
                        visibility: "visible",
                        top: "3px !important",
                    },
                }}
                anchorPosition={
                    contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }
            >
                <MenuItem
                    onMouseLeave={closeContextMenu}
                    onClick={(e) => {
                        if (!handleCloseAll(e)) {
                            setContextMenu(null);
                        }
                    }}
                >
                    Alle Tabs schließen
                </MenuItem>
            </Menu>
        </>
    ), [currentRoute, orderedTabs, setCurrentTab, currentTab, enabled, confirmDiscard, confirmDiscardAll, contextMenu, isHelpDesk])
    );
}
